// extracted by mini-css-extract-plugin
export default {"container":"Xhr+PzBF12","pagination":"UD8Hxx892M","pagination-cell":"gwacJPKLQ4","paginationCell":"gwacJPKLQ4"};